// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__11U7p","disabled":"FileBtn_disabled__2xke3","warn":"FileBtn_warn__D4Wbb","fade":"FileBtn_fade__28FqK"};